import { DateTime } from 'luxon';
import { replaceAll } from '@/utils/stringUtils';

export const formatDate = (date: string | Date | null | undefined, format = 'yyyy-LL-dd', isLocal = true, lang = 'en-US') => {
  if (!date) {
    return '';
  }
  const datetime = DateTime.fromJSDate(new Date(date));
  const datetimeDisplayByTimezone = datetime.setZone('utc').setLocale(lang);
  const datetimeDisplayByTimezoneFormat = datetimeDisplayByTimezone.toFormat(format);
  const datetimeDisplayByTimezoneLocalFormat = datetimeDisplayByTimezone.toLocal().toFormat(format);
  return isLocal ? replaceAll(datetimeDisplayByTimezoneLocalFormat, '\\.', '') : replaceAll(datetimeDisplayByTimezoneFormat, '\\.', '');
};

export const formatDateAllowLanguage = (date: string | null | undefined, currentLanguage: string) => {
  if (!date) {
    return '';
  }

  const format = 'dd-LLL-yyyy';
  const datetime = DateTime.fromISO(date, { zone: 'utc' });
  const datetimeDisplayByLanguage = datetime.setZone('utc').setLocale(currentLanguage);
  const formattedDate = datetimeDisplayByLanguage.toFormat(format);
  return replaceAll(formattedDate, '\\.', '');
};

export const resetTimer = (originalDateTime: string | null | undefined) => {
  if (!originalDateTime) {
    return '';
  }

  const date = new Date(originalDateTime);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const timer = `${year}-${month}-${day}T00:00:00`;
  return timer;
};

export const getMonthYear = (dateString: string) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${year}`;
};
